import getCustomerSignup from './state';
import tmsService from '../../services/axios/tmsService';
import qs from 'qs';
import { isUndefined } from 'util';

const state = {
    customerSignup: getCustomerSignup(),
};

function cleanObj(obj: any) {
    for (let key of Object.keys(obj)) {
        obj[key] = '';
    }
}

const mutations = {
    updateShipInfoCompany(state: any, company: any) {
        state.customerSignup.customerSignupBody.signupPart.shipInfo.company = company;
    },
    updateCustomerSignup(state: any, customerSignup: any) {
        // {'signupPart': signupPart, 'addInfoPart': question};
        let newCustomerSignup = transferDataToState(state.customerSignup, customerSignup);
        Object.assign(state.customerSignup.customerSignupBody, newCustomerSignup);
        state.customerSignup.customerSignupBody.loopAccountCounter =
            state.customerSignup.customerSignupBody.signupPart.accounts.length;
    },
    updateAccount(state: any, users: any) {
        state.customerSignup.customerSignupBody.signupPart.accounts = users;
    },
    deleteAccountLine(state: any, index: number) {
        state.customerSignup.customerSignupBody.signupPart.accounts.splice(index, 1);
        console.log(index);
        console.log(state.customerSignup.customerSignupBody.signupPart.accounts);
    },

    addAccountLine(state: any) {
        let account = state.customerSignup.getAccountInfo();
        state.customerSignup.customerSignupBody.signupPart.accounts.push(account);
    },
    updateCreateAccountError(state: any, createAccountError: number) {
        if (createAccountError != 0) {
            Object.assign(state.customerSignup, {
                createAccountError: parseInt(state.customerSignup.createAccountError) + 1,
            });
        } else {
            Object.assign(state.customerSignup, { createAccountError: 0 });
        }
    },
    resetCustomerSignup(state: any) {
        state.customerSignup.customerSignupHeader.currentStage = 1;
        state.customerSignup.customerSignupBody.signupPart.sameAsShippingAddress = 1;
        cleanObj(state.customerSignup.customerSignupBody.signupPart.shipInfo);
        cleanObj(state.customerSignup.customerSignupBody.signupPart.billInfo);
        cleanObj(state.customerSignup.customerSignupBody.signupPart.billInfoTemp);
        state.customerSignup.customerSignupBody.signupPart.accounts = [
            state.customerSignup.getAccountInfo(),
        ];
        state.customerSignup.customerSignupBody.signupPart.sameAsShippingAddress = false;
        state.customerSignup.customerSignupBody.signupPart.billInfo.creditLimit = '500';
        cleanObj(state.customerSignup.customerSignupBody.addInfoPart);
    },
    updateStage(state: any, formData: any) {
        state.customerSignup.customerSignupHeader.currentStage = formData.currentStage;
    },
    updateShipAddress(state: any, formData: any) {
        state.customerSignup.customerSignupBody.signupPart.shipInfo.state = formData.state;
        state.customerSignup.customerSignupBody.signupPart.shipInfo.zip = formData.zip;
        state.customerSignup.customerSignupBody.signupPart.shipInfo.city = formData.city;
    },
    updateBillingAddress(state: any, formData: any) {
        state.customerSignup.customerSignupBody.signupPart.billInfo.state = formData.state;
        state.customerSignup.customerSignupBody.signupPart.billInfo.zip = formData.zip;
        state.customerSignup.customerSignupBody.signupPart.billInfo.city = formData.city;
    },
    updateBillingInfo(state: any) {
        if (state.customerSignup.customerSignupBody.signupPart.sameAsShippingAddress) {
            // copy bill info to temp
            state.customerSignup.customerSignupBody.signupPart.billInfoTemp = {
                ...state.customerSignup.customerSignupBody.signupPart.billInfo,
            };
            // copy ship info to bill info
            for (let key of Object.keys(
                state.customerSignup.customerSignupBody.signupPart.billInfo
            )) {
                if (
                    !isUndefined(state.customerSignup.customerSignupBody.signupPart.shipInfo[key])
                ) {
                    state.customerSignup.customerSignupBody.signupPart.billInfo[key] =
                        state.customerSignup.customerSignupBody.signupPart.shipInfo[key];
                }
            }
        } else {
            // copy temp to bill info
            state.customerSignup.customerSignupBody.signupPart.billInfo = {
                ...state.customerSignup.customerSignupBody.signupPart.billInfoTemp,
            };
        }
    },
    syncBillingInfoOnInput(state: any) {
        // copy ship info to bill info
        for (let key of Object.keys(state.customerSignup.customerSignupBody.signupPart.billInfo)) {
            if (!isUndefined(state.customerSignup.customerSignupBody.signupPart.shipInfo[key])) {
                state.customerSignup.customerSignupBody.signupPart.billInfo[key] =
                    state.customerSignup.customerSignupBody.signupPart.shipInfo[key];
            }
        }
    },
    updateShowLoding(state: any, showLoding: boolean) {
        state.customerSignup.customerSignupBody.showLoding = showLoding;
    },
    updateShowLoadingBar(state: any, showLoding: boolean) {
        state.customerSignup.customerSignupBody.showLoadingBar = showLoding;
    },
};

const actions = {
    updateShipInfoCompany(store: any, company: any) {
        store.commit('updateShipInfoCompany', company);
    },
    deleteAccountLine(store: any, index: number) {
        store.commit('deleteAccountLine', index);
    },
    addAccountLine(store: any) {
        store.commit('addAccountLine');
    },
    updateStage(store: any, formData: any) {
        store.commit('updateStage', formData);
    },
    sameAsShippingAddressChanged(store: any) {
        store.commit('updateBillingInfo');
    },
    updateShipAddress(store: any, formData: any) {
        store.commit('updateShipAddress', formData);
    },
    updateBillingAddress(store: any, formData: any) {
        store.commit('updateBillingAddress', formData);
    },
    syncBillingInfoOnInput(store: any) {
        store.commit('syncBillingInfoOnInput');
    },
    async initCustomerSignup(store: any, shipperLocationId: number) {
        store.commit('updateShowLoadingBar', true);

        try {
            let response = await tmsService.post(
                'write_new/get_customer_signup.php',
                qs.stringify({ shipper_location_id: shipperLocationId })
            );

            if (response.data.status == 0) {
                let messageModel = {};
                messageModel['isShowMessageModel'] = true;
                messageModel['messageModelTitle'] = 'Error';
                // messageModel["messageModelMessage"] = "signup Success! user account:" + response.data.userId + ", password:" + response.data.password;
                messageModel['waitMillsSecondsToClose'] = 0;
                messageModel['clickToClose'] = true;
                if (response.data.error) {
                    messageModel['messageModelMessage'] = response.data.error;
                } else {
                    messageModel['messageModelMessage'] =
                        'Load Customer Signup Data' + shipperLocationId + ' error!';
                }

                store.dispatch('updateMessageModel', messageModel);

                console.log('get customer signup Fail!');
                console.log(response.data);
            } else if (response.data.status == 1) {
                store.commit('updateCustomerSignup', response.data.customer_signup);
            } else {
                let messageModel = {};
                messageModel['isShowMessageModel'] = true;
                messageModel['messageModelTitle'] = 'Error';
                messageModel['waitMillsSecondsToClose'] = 20;
                messageModel['clickToClose'] = true;
                messageModel['messageModelMessage'] = 'Load Account error!';
                store.dispatch('updateMessageModel', messageModel);
                console.log('Init Account Fail!');
                console.log(response);
            }
        } catch (error) {
            let messageModel = {};
            messageModel['isShowMessageModel'] = true;
            messageModel['messageModelTitle'] = 'Error';
            messageModel['waitMillsSecondsToClose'] = 20;
            messageModel['clickToClose'] = true;
            messageModel['messageModelMessage'] = 'Init Customer Signup Page error!';
            store.dispatch('updateMessageModel', messageModel);
            console.log('Init Account Fail!');
            console.log(error);
        } finally {
            store.commit('updateShowLoadingBar', false);
        }
    },
    async createAccount(store: any, formData: any) {
        store.commit('updateShowLoding', true);
        try {
            let query_data = collectData(store);
            let response = await tmsService.post(
                'write_new/write_customer_signup.php',
                qs.stringify({ accountData: query_data })
            );

            if (response.data.status == 0) {
                let messageModel = {};
                messageModel['isShowMessageModel'] = true;
                messageModel['messageModelTitle'] = 'Error';
                // messageModel["messageModelMessage"] = "signup Success! user account:" + response.data.userId + ", password:" + response.data.password;
                messageModel['waitMillsSecondsToClose'] = 0;
                messageModel['clickToClose'] = true;
                if (response.data.error) {
                    messageModel['messageModelMessage'] = response.data.error;
                } else {
                    if (response.data.users) {
                        let error = '';
                        response.data.users.forEach((item: any) => {
                            if (item['error']) {
                                error += item['error'];
                            }
                        });
                        messageModel['messageModelMessage'] = error;
                        store.dispatch('updateAccount', response.data.users);
                    }
                }

                store.dispatch('updateMessageModel', messageModel);

                console.log('Create Account Fail!');
                console.log(response.data);
            } else if (response.data.status == 1) {
                store.commit('updateCreateAccountError', 0);
                let messageModel = {};
                messageModel['isShowMessageModel'] = true;
                messageModel['messageModelTitle'] = 'Success';
                // messageModel["messageModelMessage"] = "signup Success! user account:" + response.data.userId + ", password:" + response.data.password;
                messageModel['messageModelMessage'] = 'Customer account successfully created.';
                // messageModel["waitMillsSecondsToClose"] = 0;
                store.dispatch('updateMessageModel', messageModel);
                store.commit('resetCustomerSignup');
                window.location.href = 'index.html#/home';
            } else {
                store.commit('updateCreateAccountError', 1);
                console.log('Create Account Fail!');
                console.log(response);
            }
        } catch (error) {
            store.commit('updateCreateAccountError', 1);
            console.log('Create Account Fail!');
            console.log(error);
        } finally {
            store.commit('updateShowLoding', false);
        }
    },
    clearCustomerSignup(store: any) {
        store.commit('resetCustomerSignup');
    },
};

function transferDataToState(customerSignupState: any, customerSignup: any) {
    let signupPart = customerSignupState.getSignUpPart();
    let question = customerSignupState.getAddInfoPart();
    if (customerSignup && customerSignup['question']) {
        question = customerSignup['question'];
    }
    if (customerSignup && customerSignup['shipping']) {
        signupPart.shipInfo = {
            locationId: customerSignup['shipping']['locationId'],
            company: customerSignup['shipping']['locationName'],
            address1: customerSignup['shipping']['address1'],
            address2: customerSignup['shipping']['address2'],
            city: customerSignup['shipping']['city'],
            state: customerSignup['shipping']['state'],
            zip: customerSignup['shipping']['zip'],
            phone: customerSignup['shipping']['phone'],
            fax: customerSignup['shipping']['fax'],
        };
    }
    if (customerSignup && customerSignup['billInfo']) {
        signupPart.billInfo = {
            locationId: customerSignup['billing']['locationId'],
            company: customerSignup['billing']['locationName'],
            address1: customerSignup['billing']['address1'],
            address2: customerSignup['billing']['address2'],
            city: customerSignup['billing']['city'],
            state: customerSignup['billing']['state'],
            zip: customerSignup['billing']['zip'],
            phone: customerSignup['billing']['phone'],
            fax: customerSignup['billing']['fax'],
            creditLimit: customerSignup['billing']['creditLimit'],
        };
    }

    if (customerSignup && customerSignup['users']) {
        signupPart.accounts = [...customerSignup['users']];
    }

    if (customerSignup['sameAsShippingAddress']) {
        signupPart.sameAsShippingAddress = customerSignup['sameAsShippingAddress'];
    }
    return { signupPart: signupPart, addInfoPart: question };
}

function collectData(store: any) {
    let signupBody = store.getters.customerSignupBody;
    let formData = {
        shipping: {
            locationId: signupBody.signupPart.shipInfo.locationId,
            locationName: signupBody.signupPart.shipInfo.company,
            address1: signupBody.signupPart.shipInfo.address1,
            address2: signupBody.signupPart.shipInfo.address2,
            city: signupBody.signupPart.shipInfo.city,
            state: signupBody.signupPart.shipInfo.state,
            zip: signupBody.signupPart.shipInfo.zip,
            phone: signupBody.signupPart.shipInfo.phone,
            fax: signupBody.signupPart.shipInfo.fax,
        },
        billing: {
            locationId: signupBody.signupPart.billInfo.locationId,
            locationName: signupBody.signupPart.billInfo.company,
            address1: signupBody.signupPart.billInfo.address1,
            address2: signupBody.signupPart.billInfo.address2,
            city: signupBody.signupPart.billInfo.city,
            state: signupBody.signupPart.billInfo.state,
            zip: signupBody.signupPart.billInfo.zip,
            phone: signupBody.signupPart.billInfo.phone,
            fax: signupBody.signupPart.billInfo.fax,
            creditLimit: signupBody.signupPart.billInfo.creditLimit,
        },
        users: [...signupBody.signupPart.accounts],
        question: signupBody['addInfoPart'],
    };
    return formData;
}

function waitSeconds(time: number) {
    return new Promise(function(resolve, reject) {
        setTimeout(function() {
            resolve();
        }, time);
    });
}
const getters = {
    getCreateAccountError(state: any) {
        return state.customerSignup.createAccountError;
    },
    customerSignupHeader(state: any) {
        return state.customerSignup.customerSignupHeader;
    },
    currentStage(state: any) {
        return state.customerSignup.customerSignupHeader.currentStage;
    },
    customerSignupBody(state: any) {
        return state.customerSignup.customerSignupBody;
    },
};

const customerSignupModule = {
    state,
    mutations,
    actions,
    getters,
};

export default customerSignupModule;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/store/customerSignup/customerSignupModule.ts